export const ParticipantType = {
  Teacher: 'Teacher',
  Learner: 'Learner'
};

export const RoomStatus = {
  NotCreated: 'NotCreated',
  Connecting: 'Connecting',
  Connected: 'Connected',
  Ending: 'Ending'
};

export const intercomWidgetRight = 100;

export const membersDrawerWidth = 300;

export const LiveClassEventType = {
  CARD_CHANGED: 'CARD_CHANGED',
  CARD_COMPLETE: 'CARD_COMPLETE',
  CHAT: 'CHAT'
};

export const Keys = {
  Enter: 13
};
